import React, { Component } from 'react';
import { connect } from 'react-redux';
import { userActions } from '../../actions';

class Login extends Component {
    constructor(props) {
        super(props);

        // reset login status
        this.props.dispatch(userActions.logout());

        this.state = {
            username: '',
            password: '',
            submitted: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });
        const { username, password } = this.state;
        const { dispatch } = this.props;
        if (username && password) {
            dispatch(userActions.login(username, password));
        }
    }
   
    render() { 
        const { loggingIn } = this.props;
        const { username, password, submitted } = this.state;
        return (  
            <div className="container">
                <div className="row">
                    
                    <div class="col-md-4 col-md-offset-4 text-center">
                        <p></p>
                        <img src="/content/images/dp.png" width="230" />
                     </div>
                     <div class="col-md-4 col-md-offset-4 text-center">
                        <h3>سامانه دادپزشک</h3>
                    </div>
                    <div className="col-md-4 col-md-offset-4">
                        <div className="login-panel panel panel-default">
                            <div className="panel-heading">
                                <h3 className="panel-title">ورود به سامانه</h3>
                            </div>
                            <div className="panel-body">
                                <form role="form"  onSubmit={this.handleSubmit}>
                                    <fieldset>
                                        <div className="form-group">
                                            <input className="form-control" placeholder="ایمیل" name="username" type="text" autoFocus value={username} onChange={this.handleChange}></input>
                                        </div>
                                        <div className="form-group">
                                            <input className="form-control" placeholder="رمز عبور" name="password" type="password" value={password} onChange={this.handleChange}></input>
                                        </div>
                                       
                                        <button className="btn btn-block btn-md btn-primary">ورود
                                            { loggingIn &&
                                                <i className="fa fa-spinner fa-spin"></i>
                                            }
                                        </button>

                                        <a href="./ForgotPassword">فراموشی رمز عبور</a>
                                       
                                    </fieldset>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    const { loggingIn } = state.authentication;
    return {
        loggingIn
    };
} 

export default connect(mapStateToProps)(Login);